import { Step } from '@tiptap/pm/transform'
import { HistoryCurrentVersion, HistoryVersion } from '../types'
import getFeatureEditor from '../../getEditor'
import { IS_HISTORY_CHANGE } from '../../constants'

export const filterEditorMarks = (json: ReturnType<Step['toJSON']>) => {
  // Remove the underline and highlight from marks in history
  const excludedMarks = ['customunderline', 'customhighlight']
  json?.slice?.content?.forEach((node) => {
    if (node.type === 'text' && node.marks) {
      /* eslint-disable no-param-reassign */
      node.marks = node.marks.filter((mark) => !excludedMarks.includes(mark.type))
    }
  })
}

export const getHistoryVersionWithStepInJson = (
  currentData: HistoryCurrentVersion
): HistoryVersion => {
  const stepsJson = currentData.steps.map((step) => {
    const json = step.toJSON()
    filterEditorMarks(json) // Modify this json object
    return json
  })

  const { steps, ...historyData } = {
    ...currentData,
    stepsJson,
  }
  return historyData
}

export const applyStepsAndGetInversion = (stepsJson: JSON[]): JSON[] => {
  const editor = getFeatureEditor()
  const invertedSteps = stepsJson.map((stepJson) => {
    const { state, view } = editor
    const oldDoc = state.doc
    const step = Step.fromJSON(state.schema, stepJson)
    const transaction = state.tr.step(step).setMeta(IS_HISTORY_CHANGE, true)
    view.dispatch(transaction)

    // Set the cursor at the end of the document after the step
    editor
      .chain()
      .focus()
      .setTextSelection(transaction.mapping.map((stepJson as any).to))
      .scrollIntoView()
      .run()
    const inverted = step.invert(oldDoc).toJSON()
    filterEditorMarks(inverted)
    return inverted
  })
  return invertedSteps
}
